import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import React from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Creatable from "react-select/creatable";
import { fileUpload } from "utils/helperFunctions";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File
import { toast } from "react-hot-toast";
import sendRequest from "hooks/useAxios";
import { translateToReactSelect } from "../../utils/helperFunctions";
import Loader from "utils/Loader";

export default function AddArticle({ postId, singleArticle, setUpdater }) {
  // registerPlugin(FilePondPluginImagePreview);
  const [IsLoading, setIsLoading] = useState(false);

  const navigation = useNavigate();
  // const []
  function deleteArticle() {
    Swal.fire({
      title: "آیا از حذف پست اطمینان دارید؟",
      // text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "انصراف",
    }).then((result) => {
      if (result.isConfirmed) {
        sendRequest("deletepost", { postId: postId }).then(({ data }) => {
          if (data.status == 1) {
            Swal.fire("پست با موفقیت حذف شد.");
            navigation("/blog");
          } else {
            Swal.fire("مشکلی در حذف پست پیش آمده است.");
          }
        });
      }
    });
  }

  // گرفتن برچسب از api
  const [tagsOptions, setTagsOptions] = useState([]);
  useEffect(() => {
    sendRequest("Find_hashtags").then(({ data }) => {
      setTagsOptions(translateToReactSelect(data, false));
    });
  }, []);

  //  فرستادن برچسب های جدید به API
  const [articleTag, setArticleTag] = useState([]);

  useEffect(() => {
    setLocalArticleData({ ...singleArticle, hashtags: "" });
    setArticleTag(
      translateToReactSelect(
        singleArticle.hashtags.map((value) => {
          return { id: value.hashtag_id, txt: value.txt };
        }),
        false
      )
    );
  }, [singleArticle]);

  const changeHandler = (type, value) => {
    setLocalArticleData((prev) => {
      return { ...prev, [type]: value };
    });
  };

  // بررسی خالی نبودن input  عنوان

  // بررسی خالی نبودن input  توضیحات

  const [localArticleData, setLocalArticleData] = useState({
    title: "",
    description: "",
    bodytxt: "",
    hashtags: [],
    files: [],
    file: "",
  });
  const [validationLocalArticleData, setValidationLocalArticleData] = useState({
    title: true,
    description: true,
    bodytxt: true,
  });
  const validation = () => {
    let isValid = true;
    if (localArticleData.title == "") {
      setValidationLocalArticleData((prev) => {
        return { ...prev, title: false };
      });
      isValid = false;
    } else {
      setValidationLocalArticleData((prev) => {
        return { ...prev, title: true };
      });
    }
    if (localArticleData.description == "") {
      setValidationLocalArticleData((prev) => {
        return { ...prev, description: false };
      });
      isValid = false;
    } else {
      setValidationLocalArticleData((prev) => {
        return { ...prev, description: true };
      });
    }
    if (localArticleData.bodytxt == "") {
      setValidationLocalArticleData((prev) => {
        return { ...prev, bodytxt: false };
      });
      isValid = false;
    } else {
      setValidationLocalArticleData((prev) => {
        return { ...prev, bodytxt: true };
      });
    }
    return isValid;
  };

  const updatePost = async (hashtags) => {
    setIsLoading(true);

    let convertedHashtags = await Promise.all(
      hashtags.map((arrayItem) => {
        if (arrayItem.__isNew__ == true) {
          let a = sendRequest("Insert_hashtags", { txt: arrayItem.label });
          return a;
        } else {
          return { data: { result: arrayItem } };
        }
      })
    );
    convertedHashtags = convertedHashtags.map((value) => {
      return value.data.result;
    });

    const formData = new FormData();
    formData.append("updateValue", `title,${localArticleData.title}@@description,${localArticleData.description}@@bodytxt,${localArticleData.bodytxt}`);
    formData.append("Hashtags", `${translateToReactSelect(convertedHashtags, true)}`);
    for (let i = 0; i < localArticleData.files.length; i++) {
      formData.append("files[]", localArticleData.files[i]);
    }

    formData.append("file", localArticleData.file);
    formData.append("postId", postId);

    let {
      data: { status, id },
    } = await sendRequest("updatepost", formData);
    if (status == 1) {
      toast.success("مقاله با موفقیت ویرایش شد.");
      document.querySelector(".edit-article-btn-close").click();
      setUpdater((prev) => !prev);
      // navigation to tak article
    } else {
      toast.error("مشکلی در ویرایش مقاله به وجود آمد");
    }
    setIsLoading(false);
  };

  // مدال ویرایش مطلب/
  const editArticle = (
    <div className="modal fade" id="editArticleModal" tabIndex={-1} aria-labelledby="editArticleModalLabel" aria-hidden="true">
      {IsLoading && <Loader></Loader>}

      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5>ویرایش مطلب</h5>
            <button type="button" className="btn-close edit-article-btn-close" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body">
            <div>
              <form>
                <div className="row">
                  <label for="title" className="col-4">
                    عنوان
                  </label>
                  <div className="col-8">
                    <input
                      type="text"
                      id="title"
                      className="form-control"
                      value={localArticleData.title}
                      onChange={(e) => {
                        changeHandler("title", e.target.value);
                      }}
                    />
                    <p className={`text-danger fs-12 ${validationLocalArticleData.title == false ? "d-block" : "d-none"}`}>این فیلد نمی تواند خالی باشد</p>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-4">
                    <label for="description">توضیحات</label>
                  </div>
                  <div className="col-8">
                    <input
                      type="text"
                      id="description"
                      className="form-control"
                      value={localArticleData.description}
                      onChange={(e) => {
                        changeHandler("description", e.target.value);
                      }}
                    />
                    <p className={`text-danger fs-12 ${validationLocalArticleData.description == false ? "d-block" : "d-none"}`}>این فیلد نمی تواند خالی باشد</p>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-4">
                    <label for="file">تصویر اصلی</label>
                  </div>
                  <div className="col-8">
                    <input
                      type="file"
                      id="file"
                      name="file"
                      className="form-control"
                      onChange={(e) => {
                        setLocalArticleData((prev) => {
                          return { ...prev, file: e.target.files[0] };
                        });
                      }}
                      // value={localArticleData.file}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-4">
                    <label for="files">باقی فایل ها</label>
                  </div>
                  <div className="col-8">
                    <input
                      type="file"
                      id="files"
                      name="files"
                      className="form-control"
                      multiple
                      onChange={(e) => {
                        setLocalArticleData((prev) => {
                          return { ...prev, files: e.target.files };
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-4">
                    <label for="">برچسب</label>
                  </div>
                  <div className="col-8" style={{ zIndex: 999 }}>
                    <Creatable
                      id="tags"
                      options={tagsOptions}
                      isMulti={true}
                      className="mx-1"
                      onChange={(e) => {
                        setArticleTag(e);
                      }}
                      value={articleTag}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div>
                    <label for="">متن اصلی</label>
                  </div>

                  <div className="mx-2 mt-2" style={{ direction: "rtl" }}>
                    <SunEditor
                      setOptions={{
                        height: 200,
                        buttonList: [[], ["undo", "redo", "font", "fontSize", "formatBlock", "bold", "underline", "strike", "fontColor", "textStyle", "removeFormat", "align", "horizontalRule", "list", "lineHeight", "link", "image", "video", "audio", "imageGallery", "fullScreen", "preview"]], // Or Array of button list, eg. [['font', 'align'], ['image']]
                        // plugins: [font] set plugins, all plugins are set by default
                        // Other option
                      }}
                      setContents={localArticleData.bodytxt}
                      onChange={(content) => {
                        changeHandler("bodytxt", content);
                      }}
                      value={localArticleData.bodytxt}
                    />
                  </div>
                </div>
                <p className={`text-danger fs-12 ${validationLocalArticleData.bodytxt == false ? "d-block" : "d-none"}`}>این فیلد نمی تواند خالی باشد</p>
              </form>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              بستن
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={() => {
                if (validation()) {
                  updatePost(articleTag);
                }
              }}
            >
              ذخیره
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className=" mx-5 mt-4">
        <button className="btn btn-warning p-2 mx-2" data-bs-toggle="modal" data-bs-target="#editArticleModal">
          ویرایش
        </button>
        {createPortal(editArticle, document.getElementById("modals"))}

        <button
          className="btn btn-danger p-2 mx-2"
          onClick={deleteArticle}
          // data-bs-toggle="modal"
          // data-bs-target="#deleteArticleModal"
        >
          حذف
        </button>
        {/* {createPortal(deleteArticle, document.getElementById("modals"))} */}
      </div>
    </>
  );
}
